var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { PricingNumbersService } from '../../shared/services/pricing-numbers.service';
import { Ng1IpInfoService } from '../../shared/ng1/ng1-ip-info.service';
import { map, tap } from 'rxjs/operators';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { Router } from '@angular/router';
import { MsisdnService } from '../../shared/msisdn/msisdn.service';
import { Store } from '@ngrx/store';
import { OrderInitialNumberAction } from '../pricing-numbers/pricing-numbers.action';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { AccountService } from '../../shared/services/account.service';
import { getOrderingInitialNumberSelector } from '../pricing-numbers/pricing-numbers.reducer';
var FirstNumberWelcomeComponent = /** @class */ (function () {
    function FirstNumberWelcomeComponent(pricingNumbersService, ng1IpInfoService, router, msisdnService, store, amplitudeService, accountService) {
        this.pricingNumbersService = pricingNumbersService;
        this.ng1IpInfoService = ng1IpInfoService;
        this.router = router;
        this.msisdnService = msisdnService;
        this.store = store;
        this.amplitudeService = amplitudeService;
        this.accountService = accountService;
    }
    FirstNumberWelcomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.countryCode = this.ng1IpInfoService.getCountry();
        this.logAmplitude('Init');
        this.orderingInitialNumber$ = this.store.select(getOrderingInitialNumberSelector);
        this.accountService.getAccountConfig().subscribe(function (_a) {
            var isFullyConfigured = _a.data;
            if (isFullyConfigured) {
                _this.handleAlreadyConfiguredAccount();
            }
            else {
                _this.loadNumbers();
            }
        });
    };
    FirstNumberWelcomeComponent.prototype.loadNumbers = function () {
        var _this = this;
        this.firstNumber$ = this.pricingNumbersService
            .getRandomNumberForCountry(this.countryCode)
            .pipe(tap(function (number) { return _this.handleNoNumber(number); }), map(function (number) { return _this.addMetadata(number); }));
    };
    FirstNumberWelcomeComponent.prototype.addMetadata = function (number) {
        return (number && __assign({}, number, { countryCode: this.getNumbersCountry(number.selectedMsisdnDisplayedValue), formatted: this.getNumberFormat(number.selectedMsisdnDisplayedValue) }));
    };
    FirstNumberWelcomeComponent.prototype.getNumbersCountry = function (phoneNumber) {
        var parsedNumber = phoneNumber && parsePhoneNumberFromString(phoneNumber);
        return parsedNumber && parsedNumber.country.toLowerCase();
    };
    FirstNumberWelcomeComponent.prototype.getNumberFormat = function (phoneNumber) {
        if (this.getNumbersCountry(phoneNumber) === 'us') {
            return parsePhoneNumberFromString(phoneNumber.toString()).formatNational();
        }
        else {
            return parsePhoneNumberFromString(phoneNumber.toString()).formatInternational();
        }
    };
    FirstNumberWelcomeComponent.prototype.changeNumber = function () {
        this.logAmplitude('Change number clicked');
        this.router.navigateByUrl('get-first-new-number');
    };
    FirstNumberWelcomeComponent.prototype.startCalling = function (request) {
        var number = request.selectedMsisdnDisplayedValue, id = request.selectedMsisdnId, pricingId = request.pricingId, label = request.label;
        var order = { pricingId: pricingId, label: label, selectedMsisdn: { id: id, number: number } };
        this.store.dispatch(new OrderInitialNumberAction(order));
        this.logAmplitude('Start calling', request);
    };
    FirstNumberWelcomeComponent.prototype.handleNoNumber = function (number) {
        if (!number) {
            this.logAmplitude('Cannot find initial number - use old flow');
            this.router.navigateByUrl('get-first-new-number');
        }
    };
    FirstNumberWelcomeComponent.prototype.logAmplitude = function (message, event) {
        this.amplitudeService.logEvent("Panel:Welcome:Initial number: " + message, __assign({ code: this.countryCode }, event));
    };
    FirstNumberWelcomeComponent.prototype.handleAlreadyConfiguredAccount = function () {
        this.logAmplitude('Already fully configured');
        this.router.navigateByUrl('/');
    };
    return FirstNumberWelcomeComponent;
}());
export { FirstNumberWelcomeComponent };
